export const abmStyles = {
	header: {
		backgroundColor: '#c6ddf1',
	},
	sidebar: {
		backgroundColor: '#0046AD',
		color: 'white',
	},
	title: {
		color: 'black',
	},
	button: {
		backgroundColor: '#002f5f',
		color: '#fff',
		fontWeight: 600,
		':hover': {
			backgroundColor: '#0083be',
		},
	},
	text: {
		color: '#00305e',
		buttonLoadingColor: '#FFFFFF',
	},
	table: {
		headerBackgroundColor: '#0046AD',
		headerTextColor: '#ffffff',
	},
	platformName: {
		name: 'ParkABM',
	},
	logo: {
		small: {
			src: '/abm/abm-small-logo.png',
			height: 35,
			width: 35,
		},
		large: {
			src: '/abm/abm-logo-white.png',
			height: 41,
			width: 75,
		},
	},
	favicon: {
		src: '/abm/abm-small-logo.png',
	},
	socials: {
		instagram: 'https://instagram.com/#',
		x: 'https://twitter.com/ABMFacilityServ',
		facebook: 'https://www.facebook.com/ABMIndustries/',
		linkedIn: 'https://www.linkedin.com/company/abm-industries/',
	},
	siteUrl: 'https://abmparking.com/',
	orgName: 'ABM Industries Incorporated',
};
